const setItem = (key, value, storageType = window.localStorage) => {
  storageType.setItem(key, JSON.stringify(value));
};

const getItem = (key: string): any => {
  let result: any;
  try {
    result = JSON.parse(localStorage.getItem(key));
  } catch (error) {
    result = null;
  }
  return result;
};

const setItems = (items) => {
  items.forEach((value) => {
    setItem(value.key, JSON.stringify(value.value), value.storageType);
  });
};

const getItems = (items) => {
  const itemsList = [];
  items.forEach((value) => {
    const result = getItem(value.key, value.storageType);
    itemsList.push(JSON.parse(result));
  });
  return itemsList;
};

const clearStorage = () => {
  window.localStorage.clear();
};

const removeItem = (key) => {
  localStorage.removeItem(key)
}

export { getItem, setItem, setItems, getItems, clearStorage, removeItem };
